import React from 'react';
export function Closing() {
  return <section className="py-16 px-6 bg-gray-50" data-id="element-14">
      <div className="max-w-4xl mx-auto text-center" data-id="element-15">
        <div className="mb-8" data-id="element-16">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eeXDjxt34d2RMRWbvorj65/screencapture-appliedwisdomfornonprofits-org-2025-10-02-10_11_22.png" alt="Jim Morgan Signature" className="h-16 object-contain mx-auto" style={{
          clipPath: 'inset(1440px 1450px 20px 50px)'
        }} data-id="element-17" />
        </div>
        <p className="text-lg text-gray-700 mb-4" data-id="element-18">
          Thank you for sharing the gift of wisdom with your colleagues and
          friends this holiday season. I hope these leadership principles help
          nonprofit leaders create even more positive impact in their
          communities.
        </p>
        <p className="text-lg font-medium text-[#1E3A5F]" data-id="element-19">To your success,</p>
        <p className="text-lg font-medium text-[#1E3A5F]" data-id="element-20">Jim Morgan</p>
      </div>
    </section>;
}